import storeIcon from '../../assets/store.png';
import combosIcon from '../../assets/combos.svg';
import homeIcon from '../../assets/home.png';
import netflixIcon from '../../assets/netflix.png';
import amazonIcon from '../../assets/amazon.png';
import disneyIcon from '../../assets/disney.png';
import starIcon from '../../assets/star.png';
import playIcon from '../../assets/play.png';
import crunchyrollIcon from '../../assets/crunchyroll.png';
import IPTVIcon from '../../assets/iptv.png';
import netflixCategoryPH from '../../assets/netflixCategoryPH.webp';
import amazonCategoryPH from '../../assets/amazonCategoryPH.webp';
import disneyCategoryPH from '../../assets/disneyCategoryPH.webp';
import plexCategoryPH from '../../assets/plexCategoryPH.webp';
import crunchyrollPH from '../../assets/crunchyrollPH.webp';
import hbomaxPH from '../../assets/hbomaxPH.webp';
import vixPH from '../../assets/vixPH.webp';
import iptvPH from '../../assets/iptvPH.webp';
import directvPH from '../../assets/directvPH.webp';
import spotifyPH from '../../assets/spotifyPH.webp';
import canvaProPH from '../../assets/canvaProPH.webp';
import youtubePH from '../../assets/youtubePH.webp';
import rakutenVikiPH from '../../assets/rakutenVikiPH.webp';
import pornhubPH from '../../assets/pornhubPH.webp';
import appleTVPH from '../../assets/appleTVPH.webp';
import paramountPH from '../../assets/paramountPH.webp';

export const navCategories = [
    {
        name: 'Inicio',
        icon: homeIcon,
        image: ''
    },
    {
        name: 'Tienda',
        icon: storeIcon,
        image: ''
    },
    {
        name: 'Combos',
        icon: combosIcon,
        comboPage: true,
        image: ''
    },
    {
        name: 'Netflix',
        icon: netflixIcon,
        image: netflixCategoryPH
    },
    {
        name: 'Prime Video',
        icon: amazonIcon,
        image: amazonCategoryPH
    },
    {
        name: 'Disney+',
        icon: disneyIcon,
        image: disneyCategoryPH
    },
    {
        name: 'HBOMAX',
        icon: starIcon,
        image: hbomaxPH
    },
    {
        name: 'Plex',
        icon: playIcon,
        primaryNav: false,
        image: plexCategoryPH
    },
    {
        name: 'Crunchyroll',
        icon: crunchyrollIcon,
        image: crunchyrollPH
    },
    {
        name: 'Vix',
        icon: playIcon,
        primaryNav: false,
        image: vixPH
    },
    {
        name: 'IPTV',
        icon: IPTVIcon,
        primaryNav: false,
        image: iptvPH
    },
    {
        name: 'Directv',
        image: directvPH
    },
    {
        name: 'Spotify',
        image: spotifyPH
    },
    {
        name: 'CanvaPro',
        image: canvaProPH
    },
    {
        name: 'YouTube Premium',
        image: youtubePH
    },
    {
        name: 'Rakuten viki',
        image: rakutenVikiPH
    },
    {
        name: 'AppleTV',
        image: appleTVPH
    },
    {
        name: 'Pornhub',
        image: pornhubPH
    },
    {
        name: 'Paramount',
        image: paramountPH
    },
];
